/** @format */

export enum ProductConditionStarRating {
    ZERO = '0',
    ONE = '1',
    TWO = '2',
    THREE = '3',
    FOUR = '4',
    FIVE = '5',
    SIX = '6',
}
export enum SearchFacet {
    modelCategory = 'modelCategory',
    modelBrand = 'modelBrand',
    modelProductType = 'modelProductType',
    modelSystem = 'modelSystem',
    productPrice = 'productPrice',
    productConditionStarRating = 'productConditionStarRating',
    productPriceModifier = 'productPriceModifierIds',
    modelAaBatteryCompatableModelSpecificationBool = 'modelAaBatteryCompatableModelSpecificationBool',
    modelAutoFocusPointsModelSpecificationNum = 'modelAutoFocusPointsModelSpecificationNum',
    modelBuiltInFlashModelSpecificationBool = 'modelBuiltInFlashModelSpecificationBool',
    modelBuiltInWifiModelSpecificationBool = 'modelBuiltInWifiModelSpecificationBool',
    modelBulitInMicrophoneModelSpecificationBool = 'modelBulitInMicrophoneModelSpecificationBool',
    modelCameraMountModelSpecificationPhrase = 'modelCameraMountModelSpecificationPhrase',
    modelFilterThreadMmModelSpecificationNum = 'modelFilterThreadMmModelSpecificationNum',
    modelHeadphoneJackModelSpecificationBool = 'modelHeadphoneJackModelSpecificationBool',
    modelLensMountModelSpecificationPhrase = 'modelLensMountModelSpecificationPhrase',
    modelMaximumApertureTeleFModelSpecificationNum = 'modelMaximumApertureTeleFModelSpecificationNum',
    modelMaximumApertureWideFModelSpecificationNum = 'modelMaximumApertureWideFModelSpecificationNum',
    modelMaximumFramesPerSecondModelSpecificationNum = 'modelMaximumFramesPerSecondModelSpecificationNum',
    modelMaximumIsoModelSpecificationNum = 'modelMaximumIsoModelSpecificationNum',
    modelMaximumVideoResolutionModelSpecificationPhrase = 'modelMaximumVideoResolutionModelSpecificationPhrase',
    modelMegapixelsModelSpecificationNum = 'modelMegapixelsModelSpecificationNum',
    modelMicrophoneJackModelSpecificationPhrase = 'modelMicrophoneJackModelSpecificationPhrase',
    modelMinimumFocusDistanceMModelSpecificationNum = 'modelMinimumFocusDistanceMModelSpecificationNum',
    modelSensorFormatModelSpecificationPhrase = 'modelSensorFormatModelSpecificationPhrase',
    modelStorageMediaTypeModelSpecificationPhrase = 'modelStorageMediaTypeModelSpecificationPhrase',
    modelTouchscreenModelSpecificationBool = 'modelTouchscreenModelSpecificationBool',
    modelUsbPortTypeModelSpecificationPhrase = 'modelUsbPortTypeModelSpecificationPhrase',
    modelViewfinderTypeModelSpecificationPhrase = 'modelViewfinderTypeModelSpecificationPhrase',
    modelWeightGramsModelSpecificationNum = 'modelWeightGramsModelSpecificationNum',
    modelMinimumIsoModelSpecificationNum = 'modelMinimumIsoModelSpecificationNum',
    modelMinimumShutterSpeedXSecondsModelSpecificationNum = 'modelMinimumShutterSpeedXSecondsModelSpecificationNum',
    modelMaximumVideoFrameRateFpsModelSpecificationNum = 'modelMaximumVideoFrameRateFpsModelSpecificationNum',
    modelYearOfReleaseModelSpecificationNum = 'modelYearOfReleaseModelSpecificationNum',
    modelApertureBladesModelSpecificationNum = 'modelApertureBladesModelSpecificationNum',
    modelArticulatingLcdScreenModelSpecificationBool = 'modelArticulatingLcdScreenModelSpecificationBool',
    modelAutoFocusModelSpecificationBool = 'modelAutoFocusModelSpecificationBool',
    modelBuiltInBluetoothModelSpecificationBool = 'modelBuiltInBluetoothModelSpecificationBool',
    modelBuiltInLensHoodModelSpecificationBool = 'modelBuiltInLensHoodModelSpecificationBool',
    modelCameraTypeModelSpecificationPhrase = 'modelCameraTypeModelSpecificationPhrase',
    modelDropInFilterDiameterModelSpecificationNum = 'modelDropInFilterDiameterModelSpecificationNum',
    modelFileFormatModelSpecificationPhrase = 'modelFileFormatModelSpecificationPhrase',
    modelFlashCompatibilityModelSpecificationPhrase = 'modelFlashCompatibilityModelSpecificationPhrase',
    modelHotShoeConnectionModelSpecificationBool = 'modelHotShoeConnectionModelSpecificationBool',
    modelImageStabilizationModelSpecificationBool = 'modelImageStabilizationModelSpecificationBool',
    modelIntegratedCleaningModelSpecificationBool = 'modelIntegratedCleaningModelSpecificationBool',
    modelLcdResolutionPixelsModelSpecificationNum = 'modelLcdResolutionPixelsModelSpecificationNum',
    modelLcdSizeInchesModelSpecificationNum = 'modelLcdSizeInchesModelSpecificationNum',
    modelLiveViewModelSpecificationBool = 'modelLiveViewModelSpecificationBool',
    modelMaximumShutterSpeed1SecondsModelSpecificationPhrase = 'modelMaximumShutterSpeed1SecondsModelSpecificationPhrase',
    modelMinimumApertureFModelSpecificationNum = 'modelMinimumApertureFModelSpecificationNum',
    modelOpticalZoomXModelSpecificationNum = 'modelOpticalZoomXModelSpecificationNum',
    modelSensorTypeModelSpecificationPhrase = 'modelSensorTypeModelSpecificationPhrase',
    modelShutterRatingLifeModelSpecificationNum = 'modelShutterRatingLifeModelSpecificationNum',
    modelViewfinderCoverageModelSpecificationNum = 'modelViewfinderCoverageModelSpecificationNum',
}
